import { computed, unref } from "vue";

const defaultEmailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function useEmailValidation(email, options = {}) {
    const opt = {
        required: true,
        trim: true,
        toLowerCase: true,
        regex: defaultEmailRegex,

        allowedDomains: null, // ex: ["clinica.ro"]
        blockedDomains: null, // ex: ["mailinator.com"]
        ...options,
    };

    const normalized = computed(() => {
        let v = String(unref(email) ?? "");
        if (opt.trim) v = v.trim();
        if (opt.toLowerCase) v = v.toLowerCase();
        return v;
    });

    const validations = computed(() => {
        const v = normalized.value;

        const hasValue = !!v;
        const isValidFormat = !v ? false : opt.regex.test(v);

        const domain = v.includes("@") ? v.split("@").pop() : "";
        const isAllowedDomain =
            !opt.allowedDomains || (domain && opt.allowedDomains.includes(domain));

        const isNotBlockedDomain =
            !opt.blockedDomains || (domain && !opt.blockedDomains.includes(domain));

        return {
            hasValue,
            isValidFormat,
            isAllowedDomain,
            isNotBlockedDomain,
        };
    });

    const isValid = computed(() => {
        const v = validations.value;
        if (opt.required && !v.hasValue) return false;
        if (!opt.required && !normalized.value) return true; // dacă nu e required și e gol -> ok
        return v.isValidFormat && v.isAllowedDomain && v.isNotBlockedDomain;
    });

    const errorMessage = computed(() => {
        const v = validations.value;

        if (opt.required && !v.hasValue) return "E-mail obligatoriu.";
        if (!opt.required && !normalized.value) return "";

        if (!v.isValidFormat) return "E-mail invalid (ex: doctor@clinica.ro).";
        if (!v.isAllowedDomain)
            return `E-mail-ul trebuie să fie din domeniul: ${opt.allowedDomains.join(", ")}.`;
        if (!v.isNotBlockedDomain) return "Domeniu de e-mail neacceptat.";
        return "";
    });

    return {
        normalized,
        validations,
        isValid,
        errorMessage,
    };
}